// extracted by mini-css-extract-plugin
module.exports = {"tabIcon":"NavigationTab_tabIcon__jK27j","tabTitle":"NavigationTab_tabTitle__2q_ja","InActiveTab":"NavigationTab_InActiveTab__2Uq-5","ActiveTab":"NavigationTab_ActiveTab__1juRp"};